/** Great-circle distance and the plausibility bands of SPEC §6.4. */

const R_KM = 6371.0088;

export function haversineKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1), dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * R_KM * Math.asin(Math.min(1, Math.sqrt(a)));
}

export type Plausibility = { ok: true; weight: number } | { ok: false };

/** `null` distance means request.cf had no position: skip the check, weight 0.7. */
export function plausibility(distanceKm: number | null): Plausibility {
  if (distanceKm === null) return { ok: true, weight: 0.7 };
  if (distanceKm <= 500) return { ok: true, weight: 1.0 };
  if (distanceKm <= 2000) return { ok: true, weight: 0.35 };
  return { ok: false };
}
